import { TABLES } from '../../../../Apis/Tables';
import ActiveRequestsTableApp from './Functionality/ActiveRequestsTableApp';
import RequestAccessModal from './Modal/RequestAccessModal';
import ActiveRequestsTable from './SubComponents/ActiveRequestsTable';
import ModalInput from './SubComponents/ModalInput';
import VisitorMainHeader from './SubComponents/VisitorMainHeader';
import {STATUS_MODEL} from "../../../../enums/statusEnum";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ActiveRequests = (props) => {

    const {
        view, setView, searchElement, setSearchElement,
        setBodyForExport, setFinalArray, search, setSearch,
        subView,
        handleSubViewChange,
        setSearchResults,
        viewOrigin,
        activeStep,
        modified,
        setModified
    } = props;

    const option = TABLES.REQUEST_ACCESS_EMPLOYEE

    const {
        t,
        DEV,
        permission,
        setResults,
        page,
        rowsPerPage,
        setSimpleSearch,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        getActionsButtons,
        showModal,
        modal,
        detailsModal,
        itemSelected,
        handleCancelDetails,
        handleConfirmDetails,
        handleCloseDetails,
        userId,
    } = ActiveRequestsTableApp({
        searchElement,
        setSearch,
        activeStep,
        optionTable: option,
        modified,
        setModified
    });

    return (
        <>
            <VisitorMainHeader
                DEV={DEV}
                permission={permission}
                view={view}
                setView={setView}
                subView={subView}
                handleSubViewChange={(value) => handleSubViewChange(value)}
                searchId={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setSearchResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                rowsPerPage={rowsPerPage}
                setSimpleSearch={setSimpleSearch}
                search={search}
                setSearch={setSearch}
                setFinalArray={setFinalArray}
                setResults={setResults}
                userId={userId}
                viewOrigin={viewOrigin}
            />

            <ActiveRequestsTable
                t={t}
                pagination={pagination}
                tableId={tableId}
                searchId={searchId}
                thead={thead}
                tbody={tbody}
                getActionsButtons={getActionsButtons}
            />

            {showModal &&
                <ModalInput
                    title={modal.title}
                    subtitle={modal.subtitle}
                    resume={modal.resume}
                    show={showModal}
                    statusRequest={modal.statusRequest}
                    onHide={() => {
                        modal.handleCancel();
                    }}
                    onClickFn={(e, description) => {
                        modal.handleConfirm((description == '' || description.length <= 0) ? null : description);
                    }}
                />
            }

            {(itemSelected && detailsModal) &&
                <RequestAccessModal
                    show={detailsModal}
                    confirmButton={itemSelected.statusId === STATUS_MODEL.REQUESTED}
                    cancelButton={itemSelected.statusId === STATUS_MODEL.REQUESTED}
                    buttonConfirm={'approve'}
                    buttonCancelText={'reject'}
                    onHide={() => {
                        handleCancelDetails();
                    }}
                    onConfirm={() => {
                        handleConfirmDetails();
                    }}
                    itemSelected={itemSelected}
                    onClose={() => {
                        handleCloseDetails();
                    }}
                    cancelClass="btn-color-error-600-800"
                    activeStep={activeStep}
                />
            }

        </>
    )

}

export default ActiveRequests
